import snsAxiosClient from '../common/http/http-sns';

function updateItemInfo(environmentVariables, user, updateItemInfo) {
  const payload = { ...updateItemInfo };
  const options = {
    headers: {
      ...environmentVariables.API_HEADERS_PATCH_V1,
      Authorization: `Bearer ${user.authToken}`,
    },
  };
  return snsAxiosClient(options).patch(
    `${environmentVariables.SNS_UPDATE_ITEM_INFO}${user.UUID}/updateSubscription`,
    payload,
  );
}

export default updateItemInfo;
